// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__or16V","block":"styles_block__F_qeE"};